<div class="bg-bleuCaliceo-300 bg-opacity-10 text-gray-500">
  <section class="layout py-12 lg:py-24 ">
    <h1 class="text-3xl font-semibold mb-3">{{ displayName() }}</h1>
    <p>{{ 'member' | translate }} {{ authService.user()?.erpId }}</p>
    <div class="flex flex-col-reverse gap-10 lg:flex-row mt-4 md:mt-12">
      <app-profile class="basis-8/12 mt-4 md:mt-0"></app-profile>
      <div class="basis-4/12">
        <app-credits (onCancelSeance)="viewportScroller.scrollToAnchor('next-appointment')"></app-credits>
        <button (click)="displayPlanning()" appHoverGradient class="w-full justify-center text-lg mt-4 p-4">
          {{ 'showVitalityPlanning' | translate }}
        </button>
      </div>
    </div>
  </section>
</div>

<div class="bg-white text-gray-500">
  <app-next-appointment id="next-appointment"></app-next-appointment>
  @defer (on viewport) {
    <app-account-spa-booking></app-account-spa-booking>
    <app-orders></app-orders>
  } @placeholder {
    <div class="w-full overflow-hidden h-2">
      <div class='progress w-full h-full bg-bleuCaliceo-300 left-right'></div>
    </div>
  }
</div>
